
export enum Scope {
    BF_OPS="0",
    BF_ADM="1",
    BF_ENT="2",
    BF_ORG="3"
}
